(function () {
  // ES5 only. Put this as the FIRST script in <head>, above anything that could inject GTM or Elevar.
  // Goal: block only specific script src URLs until consent is no longer fully empty, then load them.
  // Minimizes risk by avoiding Node.prototype patches and restoring hooks after release.

  var released = false;
  var BLOCKLIST = [
    /(^|\/\/)www\.googletagmanager\.com\/gtm\.js/i,
    /(^|\/\/)www\.hunterfan\.com\/a\/elevar\/static\/getelevar\/[^\/]+\/dl-web-pixel-strict-app\.js/i,
    /(^|\/\/)shopify-gtm-suite\.getelevar\.com\/getelevar\/[^\/]+\/dl-web-pixel-lax-custom\.js/i
  ];

  // Store unique blocked scripts by src
  var blockedBySrc = {}; // src -> { src: string, attrs: object }
  var blockedList = [];  // preserve insertion order

  // Keep originals so we can restore after release
  var originals = {
    scriptSetAttribute: null,
    scriptSrcDesc: null
  };

  function urlMatchesBlocklist(url) {
    if (!url) return false;
    url = String(url);
    for (var i = 0; i < BLOCKLIST.length; i++) {
      if (BLOCKLIST[i].test(url)) return true;
    }
    return false;
  }

  function safeGetAttr(el, name) {
    try {
      if (!el || !el.getAttribute) return null;
      return el.getAttribute(name);
    } catch (e) {
      return null;
    }
  }

  function captureScriptAttrs(el) {
    // Preserve attributes that can matter for CSP and loading behavior
    var attrs = {};

    try { attrs.async = !!el.async; } catch (e1) { attrs.async = false; }
    try { attrs.defer = !!el.defer; } catch (e2) { attrs.defer = false; }

    // CSP nonce can be important
    try { attrs.nonce = el.nonce || safeGetAttr(el, 'nonce') || null; } catch (e3) { attrs.nonce = null; }

    // SRI and related attributes
    attrs.integrity = safeGetAttr(el, 'integrity');
    attrs.crossorigin = safeGetAttr(el, 'crossorigin');
    attrs.referrerpolicy = safeGetAttr(el, 'referrerpolicy');

    // Some injectors set type, keep it if it was non-empty and not the neutralized type
    var t = safeGetAttr(el, 'type');
    attrs.type = t && t !== 'text/plain' ? t : null;

    return attrs;
  }

  function rememberBlocked(el, src) {
    if (!src) return;
    if (blockedBySrc[src]) return;

    blockedBySrc[src] = {
      src: src,
      attrs: el ? captureScriptAttrs(el) : {}
    };
    blockedList.push(blockedBySrc[src]);
  }

  function neutralizeScriptEl(el, src) {
    if (!el || !src) return;

    // Avoid re-doing work
    try {
      if (el.getAttribute && el.getAttribute('data-consent-blocked') === '1') {
        return;
      }
    } catch (e0) {}

    rememberBlocked(el, src);

    // Prevent the browser from loading it
    try { el.type = 'text/plain'; } catch (e1) {}
    try { el.setAttribute('data-consent-blocked', '1'); } catch (e2) {}
    try { el.setAttribute('data-blocked-src', src); } catch (e3) {}
    try { el.removeAttribute('src'); } catch (e4) {}
  }

  function applyAttrs(s, attrs) {
    if (!attrs) return;

    // Loading behavior
    try { s.async = !!attrs.async; } catch (e1) {}
    try { s.defer = !!attrs.defer; } catch (e2) {}

    // CSP nonce
    if (attrs.nonce) {
      try { s.nonce = attrs.nonce; } catch (e3) {}
      try { s.setAttribute('nonce', attrs.nonce); } catch (e4) {}
    }

    // SRI
    if (attrs.integrity) {
      try { s.setAttribute('integrity', attrs.integrity); } catch (e5) {}
    }
    if (attrs.crossorigin) {
      try { s.setAttribute('crossorigin', attrs.crossorigin); } catch (e6) {}
    }
    if (attrs.referrerpolicy) {
      try { s.setAttribute('referrerpolicy', attrs.referrerpolicy); } catch (e7) {}
    }

    // Optional type
    if (attrs.type) {
      try { s.type = attrs.type; } catch (e8) {}
    }
  }

  function alreadyOnPage(src) {
    // Prevent accidental double-load
    try {
      var nodes = document.getElementsByTagName('script');
      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        var s = null;
        try { s = (n && (n.src || (n.getAttribute && n.getAttribute('src')))) || ''; } catch (e1) { s = ''; }
        if (s && String(s) === String(src)) return true;
      }
    } catch (e2) {}
    return false;
  }

  function loadScript(entry) {
    if (!entry || !entry.src) return;

    // If something else loaded it already, do nothing
    if (alreadyOnPage(entry.src)) return;

    var s = document.createElement('script');
    applyAttrs(s, entry.attrs);

    // src last, some browsers start fetching immediately
    s.src = entry.src;

    (document.head || document.documentElement).appendChild(s);
  }

  function restoreHooks() {
    // Restore setAttribute
    try {
      if (originals.scriptSetAttribute) {
        HTMLScriptElement.prototype.setAttribute = originals.scriptSetAttribute;
      }
    } catch (e1) {}

    // Restore src property descriptor, best effort
    try {
      if (originals.scriptSrcDesc && originals.scriptSrcDesc.set) {
        Object.defineProperty(HTMLScriptElement.prototype, 'src', originals.scriptSrcDesc);
      }
    } catch (e2) {}
  }

  function releaseAllBlocked() {
    if (released) return;
    released = true;

    // Stop intercepting as soon as we release
    restoreHooks();

    for (var i = 0; i < blockedList.length; i++) {
      loadScript(blockedList[i]);
    }
  }

  // Intercept script src being set, this is the lowest-risk effective interception.
  function installHooks() {
    // Hook setAttribute for scripts
    try {
      originals.scriptSetAttribute = HTMLScriptElement.prototype.setAttribute;
      HTMLScriptElement.prototype.setAttribute = function (name, value) {
        try {
          if (!released && String(name).toLowerCase() === 'src' && urlMatchesBlocklist(value)) {
            neutralizeScriptEl(this, String(value));
            return;
          }
        } catch (e1) {}
        return originals.scriptSetAttribute.call(this, name, value);
      };
    } catch (e2) {}

    // Hook src property setter, when available
    try {
      var desc = Object.getOwnPropertyDescriptor(HTMLScriptElement.prototype, 'src');
      if (desc && desc.set) {
        originals.scriptSrcDesc = desc;
        Object.defineProperty(HTMLScriptElement.prototype, 'src', {
          configurable: true,
          enumerable: desc.enumerable,
          get: desc.get,
          set: function (value) {
            try {
              if (!released && urlMatchesBlocklist(value)) {
                neutralizeScriptEl(this, String(value));
                return;
              }
            } catch (e3) {}
            return desc.set.call(this, value);
          }
        });
      }
    } catch (e4) {}
  }

  // Block any matching scripts already present in DOM at the moment this runs
  function neutralizeExistingScripts() {
    try {
      var scripts = document.getElementsByTagName('script');
      for (var i = 0; i < scripts.length; i++) {
        var el = scripts[i];
        if (!el) continue;

        var src = '';
        try { src = el.getAttribute && el.getAttribute('src'); } catch (e1) { src = ''; }
        if (!src) {
          try { src = el.src; } catch (e2) { src = ''; }
        }

        if (!released && urlMatchesBlocklist(src)) {
          neutralizeScriptEl(el, String(src));
        }
      }
    } catch (e3) {}
  }

  // Consent logic:
  // 1) If currentVisitorConsent has any choice (any non-empty value), release.
  // 2) Only if currentVisitorConsent is fully empty, check allowed helpers.
  //    If any allowed helper is true, release. If all are false, keep blocking.

  function isAllConsentEmpty(consent) {
    if (!consent) return true;

    var keys = ['marketing', 'analytics', 'preferences', 'sale_of_data'];
    for (var i = 0; i < keys.length; i++) {
      var v = consent[keys[i]];
      if (v !== '' && v !== null && typeof v !== 'undefined') {
        return false;
      }
    }
    return true;
  }

  function getCurrentVisitorConsentSafe() {
    try {
      if (!window.Shopify || !Shopify.customerPrivacy) return null;
      if (typeof Shopify.customerPrivacy.currentVisitorConsent !== 'function') return null;
      return Shopify.customerPrivacy.currentVisitorConsent();
    } catch (e) {
      return null;
    }
  }

  function safeCallBool(fn) {
    try {
      if (typeof fn !== 'function') return false;
      return !!fn.call(Shopify.customerPrivacy);
    } catch (e) {
      return false;
    }
  }

  function anyProcessingAllowedSafe() {
    try {
      if (!window.Shopify || !Shopify.customerPrivacy) return false;

      var cp = Shopify.customerPrivacy;

      var analyticsAllowed = safeCallBool(cp.analyticsProcessingAllowed);
      var marketingAllowed = safeCallBool(cp.marketingAllowed);
      var preferencesAllowed = safeCallBool(cp.preferencesProcessingAllowed);

      return !!(analyticsAllowed || marketingAllowed || preferencesAllowed);
    } catch (e) {
      return false;
    }
  }

  function checkAndRelease() {
    if (released) return;

    var consent = getCurrentVisitorConsentSafe();

    // If any choice exists, release immediately
    if (!isAllConsentEmpty(consent)) {
      releaseAllBlocked();
      return;
    }

    // Only when fully empty, rely on "allowed" helpers
    if (anyProcessingAllowedSafe()) {
      releaseAllBlocked();
    }
  }

  function initConsentWatcher() {
    // Event based first, lowest overhead
    try {
      document.addEventListener('visitorConsentCollected', function () {
        checkAndRelease();
      });
    } catch (e1) {}

    // If Shopify offers a subscription API, use it
    try {
      if (window.Shopify && Shopify.customerPrivacy && typeof Shopify.customerPrivacy.subscribe === 'function') {
        Shopify.customerPrivacy.subscribe(function () {
          checkAndRelease();
        });
      }
    } catch (e2) {}

    // Short bounded poll in case the API becomes available later, then stop
    var tries = 0;
    var maxTries = 50;  // 50 * 200ms = 10 seconds
    var intervalMs = 200;

    var t = setInterval(function () {
      tries++;
      checkAndRelease();
      if (released || tries >= maxTries) clearInterval(t);
    }, intervalMs);

    // Also do an immediate check
    checkAndRelease();
  }

  // Install
  installHooks();
  neutralizeExistingScripts();
  initConsentWatcher();

  // Optional manual escape hatch for debugging
  window.__consentReleaseNow = releaseAllBlocked;

})();